<template>
  <section>
    <v-btn v-on:click="showEditMessageDialogStore = true" color="success" class="text-none">Edit</v-btn>
    <v-dialog v-model="showEditMessageDialogStore" max-width="600px">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">
          <v-layout column>
            <span class="title font-weight-light">Edit {{messagePrettyName}} message</span>
            <span class="font-weight-light caption">{{messageDescription}}</span>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea
              label="Body"
              v-model="messageBodyStore"
              ref="messageBodyField"
              auto-grow
              rows="3"
              :rules="[rules.message]"
            />
            <FieldsButtons
              :fields="messageFields"
              v-on:insertTag="handleInsertTag"
              :prettyFields="prettyFields"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="handleCancel()">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="handleSave()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showTestMessageDialog" :width="500">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">Test Message</v-card-title>
        <v-card-text>{{testMessage}}</v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAreYouSureDialog" :width="400">
      <v-card>
        <v-card-title primary-title class="headline warning lighten-1">
          <span
            class="title font-weight-light white--text"
          >You've made some changes, are you sure you want to exit?</span>
        </v-card-title>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn color="red darken-1" flat @click="handleYesSure()">Yes</v-btn>
            <v-btn color="blue darken-1" flat @click="handleNotSure()">No</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showErrorMessageDialog" :width="400">
      <v-card>
        <v-card-title primary-title class="headline error lighten-1 text-xs-center">
          <span class="title font-weight-light white--text">{{errorMessageDialogText}}</span>
        </v-card-title>
        <v-card-actions>
          <v-layout row justify-center>
            <v-btn color="red darken-1" flat @click="showErrorMessageDialog = false">Close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import FieldsButtons from "@/components/settings/messages_emails/FieldsButtons.vue";

import axios from "axios";
import qs from "qs";

axios.defaults.withCredentials = true;

export default {
  name: "edit_sms_message",
  components: {
    FieldsButtons
  },
  props: {
    messageKey: String,
    messagePrettyName: String,
    messageBody: String,
    messageDescription: String,
    messageFields: Array,
    prettyFields: Object,
    showEditMessageDialog: Boolean
  },
  data: function() {
    return {
      showEditMessageDialogStore: false,
      showTestMessageDialog: false,
      messageBodyStore: null,
      testMessage: null,
      closedWithButton: false,
      showAreYouSureDialog: false,
      showErrorMessageDialog: false,
      errorMessageDialogText: null,
      rules: {
        message: v =>
          ((v || "").match(/</g) || []).length ==
            ((v || "").match(/>/g) || []).length || "Tags </> must be enclosed"
      }
    };
  },
  methods: {
    updateMessage: function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/notificationConfig/sms/updateMessage`;
      axios({
        url: url,
        method: "POST",
        data: qs.stringify({
          name: this.messageKey,
          value: this.messageBodyStore
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(response) {
          if (response.data.error == "no_error") {
            self.testMessage = response.data.message.body;
            self.showTestMessageDialog = true;
            self.$emit("updatedMessage", self.messageBodyStore);
          } else if (response.data.error == "test_message_null") {
            self.messageBodyStore = self.messageBody;
            self.errorMessageDialogText =
              "Error: Test message rendered as null";
            self.showErrorMessageDialog = true;
          } else {
            self.messageBodyStore = self.messageBody;
            self.errorMessageDialogText = "Error: " + response.data.error;
            self.showErrorMessageDialog = true;
          }
        })
        .catch(function(error) {
          self.messageBodyStore = self.messageBody;
          self.errorMessageDialogText = error;
          self.showErrorMessageDialog = true;
          console.log(error);
        });
    },
    handleSave: function() {
      let openBracketCount = (this.messageBodyStore.match(/</g) || []).length;
      let closeBracketCount = (this.messageBodyStore.match(/>/g) || []).length;

      if (openBracketCount == closeBracketCount) {
        this.closedWithButton = true;
        this.showEditMessageDialogStore = false;

        this.messageBodyStore = this.messageBodyStore.trim();

        this.updateMessage();
      } else {
        this.errorMessageDialogText = "Error: Tags </> must be enclosed";
        this.showErrorMessageDialog = true;
        this.handleCancel();
      }
    },
    handleCancel: function() {
      this.closedWithButton = true;
      this.showEditMessageDialogStore = false;
      this.messageBodyStore = this.messageBody;
    },
    handleNotSure: function() {
      this.showAreYouSureDialog = false;
      this.showEditMessageDialogStore = true;
    },
    handleYesSure: function() {
      this.showAreYouSureDialog = false;
      this.closedWithButton = false;
      this.messageBodyStore = this.messageBody;
    },
    handleInsertTag: function(tag) {
      let currentMessage = this.messageBodyStore;

      let element = this.$refs.messageBodyField.$el.querySelector("textarea");
      let positionStart = element.selectionStart;
      let positionEnd = element.selectionEnd;

      let preText = currentMessage.substring(0, positionStart);
      let postText = currentMessage.substring(
        positionEnd,
        currentMessage.length
      );

      this.messageBodyStore = preText + tag + postText;

      this.$refs.messageBodyField.focus();

      let newPositionStart;
      let newPositionEnd;
      if (positionStart == positionEnd) {
        newPositionStart = positionStart + tag.length;
        newPositionEnd = newPositionStart;
      } else {
        newPositionStart = positionStart;
        newPositionEnd = newPositionStart + tag.length;
      }
      //Have to delay setting caret as re-render will set caret to end of text field
      setTimeout(() =>
        element.setSelectionRange(newPositionStart, newPositionEnd)
      );
    },
    removeError: function() {
      this.messageError = false;
    }
  },
  mounted: function() {
    this.showEditMessageDialogStore = this.showEditMessageDialog;
    this.messageBodyStore = this.messageBody;
  },
  watch: {
    showEditMessageDialog: function() {
      if (this.showEditMessageDialog) {
        this.showEditMessageDialogStore = true;
      }
    },
    showEditMessageDialogStore: function() {
      if (!this.showEditMessageDialogStore) {
        this.$emit("editDialogClosed");
        if (!this.closedWithButton) {
          if (this.messageBodyStore != this.messageBody) {
            this.showAreYouSureDialog = true;
          }
        }
        this.closedWithButton = false;
      }
    }
  }
};
</script>